var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewTransactions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 118,
    viewBox: "0 0 166 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.605 111.498C126.605 115.092 106.682 118 82.1064 118C57.5288 118 37.6055 115.092 37.6055 111.498C37.6055 107.908 57.5288 105 82.1064 105C106.682 105 126.605 107.908 126.605 111.498Z",
    fill: "#05C3DE",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9469 0C42.1037 0 8.18164 33.9318 8.18164 75.7871C8.18164 86.9373 10.608 97.5152 14.9323 107.049H152.962C157.286 97.5152 159.712 86.9373 159.712 75.7871C159.712 33.9318 125.79 0 83.9469 0Z",
    fill: "#05C3DE",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12891 107.049H156.871",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.605469 107.049H5.3408",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.66 107.049H165.395",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.643 34.5H40.1055C37.8963 34.5 36.1055 36.2909 36.1055 38.5V103.832C36.1055 106.041 37.8963 107.832 40.1055 107.832H125.643C127.852 107.832 129.643 106.041 129.643 103.832V38.5C129.643 36.2909 127.852 34.5 125.643 34.5Z",
    fill: "white",
    stroke: "#054C70"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3213 64.5918H93.4545V78.7724H75.3213V64.5918Z",
    fill: "#05C3DE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7835 93.957H55.6943V108.138H75.7835V93.957Z",
    fill: "#05C3DE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125.643 34.5H40.1055C37.8963 34.5 36.1055 36.2909 36.1055 38.5V103.832C36.1055 106.041 37.8963 107.832 40.1055 107.832H125.643C127.852 107.832 129.643 106.041 129.643 103.832V38.5C129.643 36.2909 127.852 34.5 125.643 34.5Z",
    stroke: "#054C70"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1055 50.7833H129.643V38C129.643 36.067 128.076 34.5 126.143 34.5H39.6055C37.6725 34.5 36.1055 36.067 36.1055 38V50.7833Z",
    fill: "white",
    stroke: "#054C70"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7793 42.7773H93.4315",
    stroke: "#054C70",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8691 64.6191H128.88",
    stroke: "#054C70",
    strokeLinecap: "square"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8691 79.2871H128.88",
    stroke: "#054C70",
    strokeLinecap: "square"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8691 93.957H128.88",
    stroke: "#054C70",
    strokeLinecap: "square"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7764 50.8359V107.436",
    stroke: "#054C70",
    strokeLinecap: "square"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4229 51.6504V107.069",
    stroke: "#054C70",
    strokeLinecap: "square"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3975 51.793V107.436",
    stroke: "#054C70",
    strokeLinecap: "square"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.879 51.793V107.436",
    stroke: "#054C70",
    strokeLinecap: "square"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M119.122 112.725C128.226 112.725 135.606 105.345 135.606 96.2413C135.606 87.1377 128.226 79.7578 119.122 79.7578C110.019 79.7578 102.639 87.1377 102.639 96.2413C102.639 105.345 110.019 112.725 119.122 112.725Z",
    fill: "white",
    stroke: "#086EA1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M119.373 88V104.484",
    stroke: "#05C3DE",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M110.881 96.2422H127.364",
    stroke: "#05C3DE",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewTransactions);
export default __webpack_public_path__ + "static/media/view-transactions.f2f2ae04131e503b8bdb8703922da05c.svg";
export { ForwardRef as ReactComponent };